var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2189",
  "data-name": "Group 2189",
  transform: "translate(-739 355)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_295",
  "data-name": "Rectangle 295",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(739 -355)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("g", {
  id: "play-button-arrowhead",
  transform: "translate(746.266 -349.508)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M10.04.276C8.972-.371,8.107.159,8.107,1.458v9.59c0,1.3.865,1.83,1.933,1.184l7.935-4.807a1.257,1.257,0,0,0,0-2.342Z",
  transform: "translate(-8.107 0)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "play-button-arrowhead-2",
  "data-name": "play-button-arrowhead",
  transform: "translate(747.163 -347.829)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32-2",
  "data-name": "Path 32",
  d: "M9.7.208C8.819-.28,8.107.12,8.107,1.1V8.325c0,.98.712,1.379,1.589.892L16.22,5.595c.878-.488.878-1.277,0-1.765Z",
  transform: "translate(-8.107 0)",
  fill: "#c7c7c7"
})))));
export default __webpack_public_path__ + "static/media/video-inactive.25a59a34.svg";
export { SvgComponent as ReactComponent };